<template>
  <div class="swiper-no-swiping w-100 justify-space-center d-flex flex-column">
    <div class="d-flex w-100 flex-column gap-xs align-center">
      <h1 class="font-lg">Form not available</h1>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>

<style lang="css" scoped>
  .swiper {
    width: 100% !important;
    height: 100%;
  }
</style>
